//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import StockInfoList from "./StockInfoList";
export default {
  name: 'StockList',
  mixins: [],
  components: {
    StockInfoList: StockInfoList
  },
  data: function data() {
    return {
      keys: 1
    };
  },
  created: function created() {
    this.keys = 1;
  },
  computed: {},
  methods: {
    handleTabs: function handleTabs(key) {
      this.keys = key;
    }
  }
};